import { render, staticRenderFns } from "./Carteiras.vue?vue&type=template&id=c003afec"
import script from "./Carteiras.vue?vue&type=script&lang=js"
export * from "./Carteiras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports